import _ from '@lodash';
import XAPPService from 'app/Core/services/XAPPService';
import * as Helpers from "app/Core/Helpers"
export const GET_OPORTUNIDADES = '[VINCULAR_OPORTUNIDADE APP] GET OPORTUNIDADES';
export const OPORTUNIDADE_INFO = '[VINCULAR_OPORTUNIDADE APP] OPORTUNIDADE INFO';
export const OPORTUNIDADE_WARNING = '[VINCULAR_OPORTUNIDADE APP] OPORTUNIDADE WARNING';
export const OPORTUNIDADE_ERROR = '[VINCULAR_OPORTUNIDADE APP] OPORTUNIDADE ERROR';
export const OPORTUNIDADE_CHANGE_PRELOAD = '[VINCULAR_OPORTUNIDADE APP] CHANGE PRELOAD';

const OportunidadeListState = [
    'idagendamento',
    'idparent',
    'cliente',
    'idpessoaformulariolocal',
    'origem',
    'origemdescricao',
    'inicio',
    'agendamentotag',
    'preatendimento',
];

export function list(_AAction, _AParams, _AFilter = null) {

    return (dispatch) => {
        dispatch(changePreload());
        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND && _AFilter.AND !== null) {
                AConditionsAND = _AFilter.AND;
            }

            if (_AFilter.OR && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Oportunidades", AActions, "spvwoportunidadependente", OportunidadeListState, _AAction, AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_OPORTUNIDADES,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch(changePreload())
                ])
            ).catch(error => {
                return dispatch({
                    type: OPORTUNIDADE_ERROR,
                    payload: error
                });
            });;
    };
}

export function setVinculoOportunidade(_AValue, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "", "VINCULAROPORTUNIDADE", _AValue, "", AConditionsAND, AConditionsOR);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactionagendamento", 'CUSTOM')
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: OPORTUNIDADE_WARNING,
                            payload: response.warning
                        })
                    ])
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: OPORTUNIDADE_INFO,
                            payload: response.info
                        }),
                    ]).then(() => {
                        if (!_.isNull(_ACallback)) {
                            _ACallback();
                        }
                    })
                }
            }
            ).catch(error => {
                return dispatch({
                    type: OPORTUNIDADE_ERROR,
                    payload: error
                });
            });
    };
}

function changePreload() {
    return {
        type: OPORTUNIDADE_CHANGE_PRELOAD
    }
}